module.exports = __webpack_public_path__ + "img/woman_with_phone.1cc71819.svg";